module.exports = __webpack_public_path__ + "img/notification.5e426f8c.svg";